module.exports = "/fonts/iconsmind.ttf?a925856d85799acc394635553311887a";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/assets/fonts/iconsmind/iconsmind.ttf?ioqkm7
// module id = S+jl
// module chunks = 35